import { hero } from './hero';
import { integrations } from './integrations';
import { interviews } from './interviews';

export const videoListing = { hero, integrations, interviews };
